// Timestamp helpers for Business Central panels.
//
// The backend emits naive UTC (datetime.utcnow().isoformat(), with no trailing
// 'Z'). `new Date()` reads a bare timestamp as LOCAL time, which silently
// shifts every reading by the viewer's UTC offset — so these mark it as UTC
// before parsing. Shared rather than duplicated per component: two copies of
// this rule would eventually disagree, and a half-fixed timezone bug is worse
// than an obvious one.

export function parseUtc(iso) {
  if (!iso) return null
  const normalised = /(?:Z|[+-]\d{2}:?\d{2})$/.test(iso) ? iso : `${iso}Z`
  const d = new Date(normalised)
  return Number.isNaN(d.getTime()) ? null : d
}

/** Absolute local date+time, e.g. "28 Aug 2026, 16:03". */
export function formatWhen(iso) {
  const d = parseUtc(iso)
  if (!d) return '—'
  return d.toLocaleString(undefined, {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: '2-digit', minute: '2-digit',
  })
}

/** Coarse relative age, e.g. "just now", "42m ago", "3h ago", "6d ago". */
export function formatAge(iso) {
  const d = parseUtc(iso)
  if (!d) return null
  const mins = Math.floor((Date.now() - d.getTime()) / 60000)
  if (mins < 1) return 'just now'
  if (mins < 60) return `${mins}m ago`
  const hours = Math.floor(mins / 60)
  if (hours < 24) return `${hours}h ago`
  return `${Math.floor(hours / 24)}d ago`
}

/** A waiting duration in hours rendered for humans: "3.2h" -> "3h", "50" -> "2d 2h". */
export function formatWaiting(hours) {
  if (hours == null) return '—'
  if (hours < 1) return `${Math.max(1, Math.round(hours * 60))}m`
  if (hours < 24) return `${Math.round(hours)}h`
  const days = Math.floor(hours / 24)
  const rem = Math.round(hours - days * 24)
  return rem ? `${days}d ${rem}h` : `${days}d`
}
